export default __webpack_public_path__ + "static/media/screenshot.f039a739.jpeg";